import { ProjectActions } from '@octopus-do/octopus-project-core'

import type { Indexer } from '@/hooks/useIndexer'

export interface SeoResponseItem {
  title: string
  slug: string
  description: string
}

export type SeoAction = ReturnType<typeof ProjectActions.nodes.updateNotes>

/**
 * One CSV row of the stream is one page, so it is turned into its own action:
 * the row is applied to the tree the moment it arrives, and the same actions
 * are collected for the single commit at the end.
 */
export const buildSeoAction = (
  key: string,
  { title, slug, description }: SeoResponseItem,
  indexer: Indexer<string>
): SeoAction | null => {
  const nodeId = indexer.getByIndex(Number.parseInt(key, 10))

  if (!nodeId) {
    return null
  }

  return ProjectActions.nodes.updateNotes({
    id: nodeId,
    notes: {
      seoTitle: title,
      seoSlug: slug,
      seoDescription: description,
    },
  })
}
